
import { Component, Vue } from "vue-property-decorator";
import LayoutMenu from "./layout-menu.vue";

@Component({
  components: {
    LayoutMenu
  }
})
export default class LayoutBase extends Vue {}
